// import _ from 'lodash';

const getters = {
  printerFriendly: state => state.flags.showMode.toLowerCase() === 'export',
  showWaitSpinner: state => state.flags.loadingInitialApiData
    || state.SP.flags.loadingSPData || state.LP.flags.loadingLPData
    || state.SP.flags.generatingPdf || state.LP.flags.generatingPdf
    || state.CR.flags.loadingCRData || state.CR.flags.generatingPdf,
};

export default getters;



// WEBPACK FOOTER //
// ./src/store/getters.js